export default "__VITE_ASSET__pCkUC$dt__"